import { List } from 'immutable'
import React from 'react'
import { async, fromJSX, StandardLocalWidget } from 'widgets-for-react'
import { Breadcrumbs } from '../templates/breadcrumbs.mod'
import { NotFoundPage } from '../templates/error_page.mod'
import { PressReleaseState } from './state'

export const pressReleaseWidget: StandardLocalWidget<PressReleaseState> = (state) =>
  fromJSX((setState) =>
    state.kind == 'loaded' || state.kind == 'loading' ? (
      <main className="main main--page main--press-release">
        <div className="main__inner">
          <article className="page">
            {async(state).run(setState)}

            {state.kind == 'loaded' && (
              <div className="page__inner" lang="en">
                <header className="pageheader pageheader--flat">
                  <div className="pageheader__inner">
                    <div className="pageheader__content container container--m">
                      <div className="pageheader__message">
                        <div className="pageheader__header">
                          <h1 className="pageheader__title">Press release</h1>
                        </div>
                      </div>
                      {/* <HeroVisual
                              hasFixedImg={false}
                              hasCMSImg={true}
                              hasVacancyImg={false}
                              image={``} 
                            /> */}
                    </div>
                  </div>
                </header>
                <div className="page__content">
                  <Breadcrumbs
                    breadcrumbs={[
                      { url: '/', title: 'Home' },
                      { url: '/en/press-releases', title: 'Press Releases' },
                      { url: `/en/press-releases/${state.value.id}`, title: state.value.title }
                    ]}
                  />
                  <section className="block block--text block--detail">
                    <div className="block__inner container container--m grid--block">
                      <div className="text--styled" dangerouslySetInnerHTML={{ __html: state.value.text }} />
                    </div>
                  </section>
                </div>
              </div>
            )}
          </article>
        </div>
      </main>
    ) : (
      <NotFoundPage />
    )
  )
